export default __webpack_public_path__ + "static/media/student.a4b40169.png";